<template>
  <basic-master
    masterName="タグボート"
    insertDataPageName="addon-port-master-tug-boat-insert"
    @callDelete="callDelete"
    @callSave="callSave"
    @callUpdateOrder="callUpdateOrder"
    :data="data"
    :columns="columns"
    ref="basicMaster"
  >
  </basic-master>
</template>

<script>

import BasicMaster from "../components/BasicMaster";
import { createNamespacedHelpers } from "vuex";
import { snakeCase } from "snake-case";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");
export default {
  components: {
    BasicMaster
  },
  data() {
    return {
      columns: [
        {
          displayName:"名称",
          inputType: "string",
          key: "name",
          searchable: true,
        },
        {
          displayName:"略称",
          inputType: "string",
          key: "short_name",
          searchable: true,
        },
        {
          displayName:"備考",
          inputType: "textArea",
          key: "description",
          searchable: false,
        },
      ],
      data: [],
    }
  },
  async created() {
    this.$vs.loading()
    await this.refreshData()
    this.$vs.loading.close()
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
    }),
  },
  methods: {
    ...mapActions(["fetchTugBoats", "updateTugBoat", "deleteTugBoat", "updateTugBoatOrders"]),
    async refreshData() {
      let res = await this.fetchTugBoats(this.selectedPort.id)
      this.data = res.tug_boats
    },
    async callSave(editedRowData) {
      let payload = {
        portId: this.selectedPort.id,
        id: editedRowData.id,
        body: {
          keyboard_shortcut: editedRowData.keyboard_shortcut,
          name: editedRowData.name,
          short_name: editedRowData.short_name,
          description: editedRowData.description,
          version: editedRowData.version
        }
      }
      this.$vs.loading()
      try {
        await this.updateTugBoat(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let targetKey = snakeCase(element.target)
            let index = this.columns.findIndex(column => column.key == targetKey)
            let label = this.columns[index].displayName
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.basicMaster.openErrorPopup("エラー", null, validationErrors)
        } else {
          this.$refs.basicMaster.openErrorPopup("エラー", error.message, null)
        }
      }
      this.refreshData()
      this.$vs.loading.close()
    },
    async callDelete(id) {
      let payload = {
        portId: this.selectedPort.id,
        id: id,
      }
      this.$vs.loading()
      await this.deleteTugBoat(payload)
      this.refreshData()
      this.$vs.loading.close()

      this.$vs.notify({
        title: "データを削除しました。",
        color: "danger",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-center"
      })
    },
    async callUpdateOrder(sortOrders) {
      let payload = {
        portId: this.selectedPort.id,
        body: {
          sort_orders: sortOrders
        }
      }
      this.$vs.loading()
      await this.updateTugBoatOrders(payload)
      this.refreshData()
      this.$vs.loading.close()
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
